import React, { useState } from 'react';
import { ExclamationMarkSvg, GreenTickSvg, LogoSvg, EyeSvg } from '../../icons';
import { Wrapper, Label, InputWrapper, ErrorLabel } from './components';
import PropTypes from 'prop-types';

export const Input = (props) => {
  const {
    value, onChange, labelInside,
    label, placeholder, error, warning,
    isLoading, isSuccess, disabled, readonly,
    icon, iconPosition, type,
  } = props;

  const [focused, setFocus] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div>
      {!labelInside &&
        <Label className="mb-2">
          {label}
        </Label>
      }
      <Wrapper
        focused={focused}
        error={error}
        warning={warning}
        disabled={disabled || isLoading}
        readonly={readonly}
      >
        {iconPosition === 'left' &&
          <div className="mr-1.5">
            {icon}
          </div>
        }
        {labelInside &&
          <Label small className="mt-0.5">
            {label}
          </Label>
        }
        <InputWrapper
          value={value}
          onChange={onChange}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          labelInside={labelInside}
          placeholder={placeholder}
          disabled={disabled || isLoading}
          readOnly={readonly}
          type={showPassword ? "text" : type}
        />
        {isLoading &&
          <LogoSvg />
        }
        {isSuccess &&
          <GreenTickSvg />
        }
        {iconPosition === 'right' && icon}
        {type === 'password' && <div className="cursor-pointer" onClick={() => setShowPassword(val => !val)} ><EyeSvg /></div>}
      </Wrapper>
      {(error || warning) &&
        <div className={`flex items-center mt-1.5`}>
          <div className="mr-2">
            <ExclamationMarkSvg warning={!!warning} />
          </div>
          <ErrorLabel warning={!!warning}>
            {error || warning}
          </ErrorLabel>
        </div>
      }
    </div>
  )
}

Input.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  labelInside: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  warning: PropTypes.string,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  isSuccess: PropTypes.bool,
  readonly: PropTypes.bool,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  icon: PropTypes.node,
  type: PropTypes.string,
};